<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<h1>{{ data.full_name }}</h1>
		<div class="margin-top margin-bottom flex">
			<MaterialText v-model="data.first_name" label="First name" v-on:enter="save()" />
			<MaterialText v-model="data.last_name" label="Last name" class="margin-left" v-on:enter="save()" />
		</div>
		<div class="margin-bottom">
			<MaterialDropdown label="Country" :options="countries" v-model="data.country_id" />
		</div>
		<div class="margin-bottom">
      <div v-for="(userRole) in getUserRoles">
        <MaterialToggle :label="userRole.name" v-model="user_roles[userRole.identifier]" />
      </div>
		</div>
		<div class="margin-bottom">
			<MaterialToggle v-model="data.active_account" label="Enable login (active account)" note="This option only affects the dashboard login" />
		</div>
		<div class="margin-bottom flex">
			<div>
				<MaterialText v-model="data.color" :disabled="saving" v-on:enter="save()" label="Color" />
			</div>
			<div class="margin-left">
				<div :style="'width: 26px; height: 26px; background: ' + data.color"></div>
			</div>
		</div>
		<div>
			<button v-on:click="save()" :disabled="saving">Save</button>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    loading: false,
    saving: false,
    data: {},
    user_roles: {}
  }),
  computed: {
    ...mapGetters([
      'getCountries',
      'getUserRoles',
      'getStylistUserRoles',
      'getUsers'
    ]),
    countries () {
      var list = {}

      for (var country of this.getCountries) {
        list[country.id] = country.name
      }

      return list
    }
  },
  methods: {
    load () {
      Vue.$api.get('/user/' + this.$route.params.id, {}, {
        loader: toggle => this.loading = toggle,
        callback: data => this.parse(data)
      })
    },
    save () {
      var data = this.data

      data.user_roles = this.user_roles

      Vue.$api.patch('/user/' + this.$route.params.id, data, {
        loader: toggle => this.saving = toggle,
        callback: data => {
          this.load()
          this.$store.dispatch('loadRepositories')
        }
      })
    },
    parse (data) {
      this.data = data.user
      this.data.country_id = data.user.country.id
      this.user_roles = data.user_roles

      if (typeof data.user_roles.length === 'number') {
        Vue.set(this, 'user_roles', {})
      }
    }
  },
  created () {
    this.load()
  }
}
</script>
